import React, { ChangeEvent, ReactElement } from "react";
import { useFormikContext } from "formik";
import { Textarea } from "@chakra-ui/react";
import { FieldWrapper } from "./FieldWrapper";

interface Props {
  name: string;
  placeholder?: string;
  minHeight?: string;
  label?: string;
  borderColor?: string;
  borderHoverColor?: string;
}

export function TextAreaField({
  name,
  label,
  minHeight,
  placeholder,
  borderColor = "brand.blue",
  borderHoverColor = "brand.lightBlue",
}: Props): ReactElement {
  const formikProps = useFormikContext();

  const onChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    formikProps.setFieldValue(name, event.target.value);
  };

  return (
    <FieldWrapper name={name} label={label}>
      <Textarea
        borderColor={borderColor}
        fontWeight={formikProps.values[name] ? "400" : "600"}
        focusBorderColor={borderHoverColor}
        placeholder={placeholder}
        borderWidth="2px"
        borderRadius="md"
        _hover={{ borderColor: borderHoverColor }}
        _focus={{ borderColor: borderHoverColor }}
        value={formikProps.values[name]}
        bg="white"
        id={`Text Area Field ${name}`}
        onChange={onChange}
      />
    </FieldWrapper>
  );
}
